import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailFilterActions"*/ './lazyIndex'),
    { name: 'MailFilterActions' }
);

export const lazySelectFilter: LazyAction<typeof lazyIndex.selectFilter, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.selectFilter);
export const lazySelectSort: LazyAction<typeof lazyIndex.selectSort, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.selectSort);
export const lazyClearFilter: LazyAction<typeof lazyIndex.clearFilter, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.clearFilter);
export const lazyRemoveFilterOverrideAndReloadFolder: LazyAction<
    typeof lazyIndex.removeSortByOverrideAndReloadFolder,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeSortByOverrideAndReloadFolder);
